module.exports = __webpack_public_path__ + "public/images/phone-with-dog-small.3dfb1352b1967d972fdbe9a8968693a1.png";